import React, { memo } from 'react';
import { createUseStyles, useTheme, Text, Progress, Icon } from 'hoi-poi-ui';
import { useWeb5Context } from "../../lib/Web5Context";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'ProgressContent');
const ProgressContent = _ref => {
  let {
    current,
    total = 100,
    description,
    subDescription,
    withRemaining = true
  } = _ref;
  const {
    t
  } = useWeb5Context();
  const classes = useStyles();
  const theme = useTheme();
  const percent = current && total ? (current / total * 100).toFixed() : 0;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, description && /*#__PURE__*/React.createElement(Text, null, description), subDescription && /*#__PURE__*/React.createElement(Text, null, subDescription), /*#__PURE__*/React.createElement("div", {
    className: classes.contentBox
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.contentBoxText
  }, /*#__PURE__*/React.createElement(Icon, {
    className: classes.contentBoxIcon,
    color: theme.colors.primary.black,
    name: "sync"
  }), /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, t('label_bulk_loading_complete', [percent]))), /*#__PURE__*/React.createElement(Progress, {
    className: classes.contentBoxBar,
    value: percent
  }), withRemaining && /*#__PURE__*/React.createElement(Text, {
    type: "caption"
  }, t('label_bulk_remaining', [total - current]))));
};
export default /*#__PURE__*/memo(ProgressContent);